<div class="flex items-center gap-2">
  <app-dropdown
    [label]="empresaLabel"
    [options]="empresaOptions"
    [value]="displayEmpresaValue"
    [placeholder]="'header.empresa.selectPlaceholder' | translate"
    minWidth="260px"
    maxWidth="260px"
    className="flex-row items-center gap-2 flex pb-0"
    position="bottom"
    [allowDeselectOnReselect]="true"
    [deselectValue]="null"
    [hidden]="disabled"
    [disabled]="disabled"
    (valueChange)="onEmpresaChange($event)"
  ></app-dropdown>

  @if (showSelectedEmpresaRuc) {
    <div class="ml-6 flex items-center gap-2 pb-0">
      <label class="text-sm text-gray-600 dark:text-gray-400 whitespace-nowrap">RUC:</label>
      <div class="inline-flex items-center min-h-9 min-w-[260px] max-w-[260px] px-3 text-sm leading-5 text-gray-900 bg-white border border-gray-300 rounded-md whitespace-nowrap dark:text-gray-100 dark:bg-gray-700 dark:border-gray-600">
        {{ selectedEmpresaRuc }}
      </div>
    </div>
  }


  @if(disabled) {
    <div class="text-sm text-gray-800 dark:text-gray-200 flex items-center gap-2">
      <i class="iconify" data-icon="solar:global-line-duotone"></i>
      <span class="font-bold">{{ 'header.empresa.modeLabel' | translate }}</span>
      <span>{{ 'header.empresa.global' | translate }}</span>
    </div>
  }
</div>


